<template>
  <div>
    <Dialog v-model:visible="visible" modal :closable="false" :header="title" :style="{ width: '50vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <div class="flex flex-col">
        <label class="block text-sm font-medium leading-6 text-gray-900">Macro</label>
        <div class="flex items-center">
          <input v-model="macrosCopy.macrosId" type="text" style="position: absolute; left: -9999px; top: -9999px" required />
          <Dropdown
            v-model="macrosCopy.macrosId"
            :options="macrosCopy.macros"
            filter
            option-label="name"
            option-value="id"
            placeholder="Select a Macro"
            class="md:w-14rem w-full"
            :class="{ 'ring-1 ring-red-500 focus:ring-1 focus:ring-red-500': false }"
            @change="
              ({ value }) => {
                console.log(macrosCopy.macros.find((m) => m.id === value).name);
              }
            "
          ></Dropdown>
        </div>
        <!--
        <Message v-if="edit" :closable="false" severity="info"> Please note: changing the Tag field will create a new entry instead of updating the existing one. </Message>
        -->
        <label class="mt-4 block text-sm font-medium leading-6 text-gray-900">Integration</label>
        <label :style="macrosCopy.integrations.length === 1 && { visibility: 'hidden' }" class="mb-1 text-sm">Select an Integration</label>
        <div class="flex items-center">
          <input ref="integrationNameRef" v-model="macrosCopy.integrationName" type="text" style="position: absolute; left: -9999px; top: -9999px" required />
          <Dropdown
            v-model="macrosCopy.integrationName"
            :disabled="edit || macrosCopy.integrations.length === 1"
            :options="macrosCopy.integrations"
            filter
            option-label="name"
            option-value="id"
            placeholder="Select an Integration"
            class="md:w-14rem w-full"
            :class="{ 'ring-1 ring-red-500 focus:ring-1 focus:ring-red-500': !integrationNameRef?.value?.validity?.valid && savedIntegration }"
            @change="onIntegrationChange"
          ></Dropdown>
        </div>
        <StdPropEditor v-model="macrosCopy.id" class="mt-4 w-full" :prop-def="propsDefs['id']" />
        <StdPropEditor v-model="macrosCopy.targetFieldId" class="mt-4 w-full" :prop-def="propsDefs['targetFieldId']" />
      </div>
      <template #footer>
        <Button label="Cancel" severity="secondary" autofocus @click="visible = false" />
        <Button label="Save" :disabled="!saveEnabled" severity="primary" autofocus @click="onSave" />
      </template>
    </Dialog>
  </div>
</template>

<script setup>
  import { ref, reactive, nextTick, computed, watch } from 'vue';
  import Dialog from 'primevue/dialog';
  import Button from 'primevue/button';
  import Message from 'primevue/message';
  import Dropdown from 'primevue/dropdown';
  import StdPropEditor from '@/components/Editors/StdPropEditor.vue';

  const emit = defineEmits(['save']);

  const props = defineProps({
    type: {
      type: String,
      default: '',
    },
  });

  const visible = ref(false);
  const integrationNameRef = ref(false);

  const macrosCopy = ref(reactive({}));

  const title = computed(() => {
    return `${edit.value ? 'Edit' : 'New'} Macro Trigger`;
  });

  // Definition of editable macro trigger properties
  const propsDefs = reactive({
    id: {
      type: 'string',
      required: true,
      title: 'Tag',
      description: `Tag name. When this tag is added to the ticket, the macro will be executed.`,
    },
    targetFieldId: {
      type: 'string',
      required: true,
      extraType: '',
      title: `Target Field ID`,
      description: `Specify field ID to write summary to. If not specified, summary will be added as a comment in the ticket.`,
    },
  });

  const saveEnabled = computed(() => [macrosCopy.value.id, macrosCopy.value.integrationName, macrosCopy.value.macrosId].every(Boolean));
  const edit = ref(false);

  const savedIntegration = ref(false);

  async function start(macrosDoc, integrations, macros) {
    edit.value = Object.keys(macrosDoc).length;

    const macrosEditableProps = {
      id: macrosDoc?.id || '',
      targetFieldId: macrosDoc?.targetFieldId || '',
      macrosId: macrosDoc?.macrosId || '',
      integrationName: integrations.length === 1 ? integrations[0].id : macrosDoc?.integrationName || null,
      integrations,
      macros,
    };
    macrosCopy.value = reactive(JSON.parse(JSON.stringify(macrosEditableProps)));

    visible.value = true;
  }

  function onSave() {
    const { id, integrationName, macrosId, targetFieldId } = macrosCopy.value;
    emit('save', { id, integrationName, macrosId, targetFieldId });
    visible.value = false;
  }

  function onIntegrationChange() {
    savedIntegration.value = false;
  }

  defineExpose({ start });
</script>
